import { render, staticRenderFns } from "./DigitalPaperFieldEdit.vue?vue&type=template&id=36e5b46d&"
import script from "./DigitalPaperFieldEdit.vue?vue&type=script&lang=ts&"
export * from "./DigitalPaperFieldEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports